import type { FirebaseApp } from 'firebase/app';
import { Messaging } from 'firebase/messaging';
import {
  Analytics,
  CustomParams,
  getAnalytics,
  logEvent as firebaseLogEvent,
  setUserProperties as firebaseSetUserProperties,
  setUserId,
} from 'firebase/analytics';
import { nanoid } from 'nanoid';
import { gql } from '@apollo/client';
import { Firebase_SetUserProperty_UserFragment } from '@ui/utils/SALogEvent/mildangFirebase.generated';

let app: FirebaseApp | null = null;
const messaging: Messaging | null = null;
let analytics: Analytics | null = null;

let screenName: string | undefined = undefined;

const BUTTON_EVENT_SUFFIX = '_btn';
const CHECKBOX_BUTTON_EVENT_SUFFIX = '_checkBtn';

const getCommonEventParameter = () => {
  return {
    browser: window.navigator.userAgent,
    screen_name: screenName,
    timestamp: Date.now(),
  };
};

const sendLogEvent = (eventName: string, params?: CustomParams) => {
  if (analytics) {
    firebaseLogEvent(analytics, eventName, {
      ...getCommonEventParameter(),
      ...params,
    });
  }
};

export const mildangFirebaseAnalytics = {
  init: (app: FirebaseApp) => {
    analytics = getAnalytics(app);
  },
  setUserProperties: (params: Firebase_SetUserProperty_UserFragment) => {
    let deviceId = localStorage.getItem('device-id');
    if (!deviceId) {
      deviceId = nanoid(26);
      localStorage.setItem('device-id', deviceId);
    }
    if (analytics) {
      const { id, manager, ...rest } = params;
      firebaseSetUserProperties(analytics, {
        env_type: process.env.NEXT_PUBLIC_APP_ENV,
        device_id: deviceId,
        manager_id: manager?.id,
        ...rest,
      });
      setUserId(analytics, id);
    }
  },
  setScreenName: (name?: string) => {
    screenName = name;
  },
  logEvent: (eventName: string, eventParams?: CustomParams) => {
    sendLogEvent(eventName, eventParams);
  },
  buttonLogEvent: (
    eventName: string,
    eventParams?: {
      [key: string]: any;
    },
  ) => {
    sendLogEvent(`${eventName}${BUTTON_EVENT_SUFFIX}`, eventParams);
  },
  checkboxButtonLogEvent: (
    eventName: string,
    eventParams?: {
      [key: string]: any;
    },
  ) => {
    sendLogEvent(`${eventName}${CHECKBOX_BUTTON_EVENT_SUFFIX}`, eventParams);
  },
};

export const initMildangFirebaseApp = async () => {
  try {
    const { initializeApp } = await import('firebase/app');

    app = initializeApp({
      apiKey: 'AIzaSyANx4T9P-yk_7_eLIhjcMIOXaRtqp9IJwA',
      // apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
      authDomain: 'mildang-a1cdd.firebaseapp.com',
      databaseURL: 'https://mildang-a1cdd.firebaseio.com',
      projectId: 'mildang-a1cdd',
      storageBucket: 'mildang-a1cdd.appspot.com',
      messagingSenderId: '974697893751',
      appId: '1:974697893751:web:83633c8a835c0ceb941b72',
      measurementId: 'G-GQTDCK0J3V',
    });

    // firebaseCloudMessaging.init(app).catch(console.warn);
    mildangFirebaseAnalytics.init(app);
  } catch (e) {}
};

gql`
  fragment Firebase_SetUserProperty_User on User {
    id
    email
    name
    manager {
      id
    }
  }
`;
